import { useCallback } from 'react'
import { authService } from '@oneblink/apps'
import { useAppConfig } from 'Providers/AppConfigProvider'
import styled from 'styled-components'

const Login = styled.button`
  margin-top: 10px !important;
`
Login.displayName = 'Login'

function LogInButton() {
  const { formsOAuthClientId } = useAppConfig()
  const signIn = useCallback(async () => {
    formsOAuthClientId && (await authService?.loginHostedUI(formsOAuthClientId))
  }, [formsOAuthClientId])

  return (
    <Login className="button ob-button is-primary" onClick={signIn}>
      Log In
    </Login>
  )
}

export default LogInButton
